<template>
  <div id="home">
    <div class="div">
      <div class="inquiries" v-loading="loadingInquiries" v-if="on('call')">
        <div class="title">
          Engagement
          <a @click="go('/monthlyAnalytics')"><i class="el-icon-more"></i></a>
        </div>
        <div class="list">
          <div class="item" @click="go('/callInquiriesDashboard')">
            <div class="icon">
              <i class="el-icon-phone"></i>
            </div>
            <div>
              <h1>Calls</h1>
              <p v-if="inquiry && inquiry.calls">{{inquiry.calls.month_call_count}}<span :class="inquiry.calls.change_rate >= 0 ? '' : 'negative_number'">{{inquiry.calls.change_rate >= 0 ? '+' : ''}}{{(inquiry.calls.change_rate * 100).toFixed(2)}}%</span></p>
            </div>

          </div>
          <div class="item" @click="go('/webInquiries')">
            <div class="icon">
              <i class="el-icon-s-promotion"></i>
            </div>
            <div>
              <h1>Web Inquries</h1>
              <p v-if="inquiry && inquiry.web_inquiries1">{{inquiry.web_inquiries1.month_web_inquiry}}<span :class="inquiry.web_inquiries1.change_rate >= 0 ? '' : 'negative_number'">{{inquiry.web_inquiries1.change_rate >= 0 ? '+' : ''}}{{(inquiry.web_inquiries1.change_rate * 100).toFixed(2)}}%</span></p>
            </div>

          </div>
          <div class="item">
            <div class="icon">
              <i class="el-icon-user-solid"></i>
            </div>
            <div>
              <h1>New Customer</h1>
              <p v-if="inquiry && inquiry.new_customers">{{inquiry.new_customers.month_new_customer_rate}}<span :class="inquiry.new_customers.change_rate >= 0 ? '' : 'negative_number'">{{inquiry.new_customers.change_rate >= 0 ? '+' : ''}}{{(inquiry.new_customers.change_rate * 100).toFixed(2)}}%</span></p>
            </div>

          </div>
        </div>
      </div>
      <div class="analytics" v-if="on('social')">
        <div class="title">
          Social Media Analytics
          <a @click="go('/socialMedia')"><i class="el-icon-more"></i></a>
        </div>
        <div class="list">
          <div class="item">
            <img style="cursor: pointer;" src="../assets/imgs/icons/icon_pro1.png" @click="jump_to_external_links(instagram_url)">
            <h1 style="color: #613C88;">Instagram</h1>
            <div style="display: flex;justify-content: center;">
              <span style="background-color: #613C88;">NEW</span>
              30 days
            </div>
            <div style="background-color: #FFF8FF;display: flex;flex-direction: column;padding:10px;border-radius: 6px;">
              <p>Likes<b v-if="socialMediaAnalytics.instagram">{{socialMediaAnalytics.instagram.likes}}</b></p>
              <p>Comments<b v-if="socialMediaAnalytics.instagram">{{socialMediaAnalytics.instagram.comments}}</b></p>
              <p>Followers<b v-if="socialMediaAnalytics.instagram">{{socialMediaAnalytics.instagram.followers}}</b></p>
            </div>
          </div>
          <div class="item">
            <img style="cursor: pointer;" src="../assets/imgs/icons/icon_pro2.png" @click="jump_to_external_links(facebook_url)">
            <h1 style="color: #0866FF;">Facebook</h1>
            <div style="display: flex;justify-content: center;">
              <span style="background-color: #0866FF;">NEW</span>
              30 days
            </div>
            <div style="background-color: #EEF9FF;display: flex;flex-direction: column;padding:10px;border-radius: 6px;">
              <p>Likes<b v-if="socialMediaAnalytics.facebook">{{socialMediaAnalytics.facebook.likes}}</b></p>
              <p>Comments<b v-if="socialMediaAnalytics.facebook">{{socialMediaAnalytics.facebook.comments}}</b></p>
              <p>Followers<b v-if="socialMediaAnalytics.facebook">{{socialMediaAnalytics.facebook.followers}}</b></p>
            </div>
          </div>
          <div class="item">
            <img src="../assets/imgs/icons/icon_pro3.png">
            <h1>TikTok</h1>
            <div style="display: flex;justify-content: center;">
              <span style="background-color: #000000;">NEW</span>
              30 days
            </div>
            <div style="background-color: #F6F6F6;display: flex;flex-direction: column;padding:10px;border-radius: 6px;">
              <p>Likes<b v-if="socialMediaAnalytics.tiktok">50</b></p>
              <p>Comments<b v-if="socialMediaAnalytics.tiktok">50</b></p>
              <p>Followers<b v-if="socialMediaAnalytics.tiktok">50</b></p>
            </div>
          </div>
          <div class="item">
            <img src="../assets/imgs/icons/icon_pro4.png">
            <h1 style="color: #007EBB;">LinkedIn</h1>
            <div style="display: flex;justify-content: center;">
              <span style="background-color: #007EBB;">NEW</span>
              30 days
            </div>
            <div style="background-color: #EFF8FA;display: flex;flex-direction: column;padding:10px;border-radius: 6px;">
              <p>Likes<b v-if="socialMediaAnalytics.linkedin">50</b></p>
              <p>Comments<b v-if="socialMediaAnalytics.linkedin">50</b></p>
              <p>Followers<b v-if="socialMediaAnalytics.linkedin">50</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seo" v-loading="loading" v-if="on('seo')">
      <div class="title">
        SEO Anaytics Report
        <a @click="go('/seo')"><i class="el-icon-more"></i></a>
      </div>
      <div class="newContent">
        <div class="bigItem">
          <h1>Google</h1>
          <div class="contentSmall">
            <div class="item">
              <div>
                <img src="../assets/imgs/home_car.png"/>
                <p>
                  Business Profile Interaction
                </p>
              </div>
              <b>{{seoMain.business_profile_interaction}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_icon.png"/>
                <p>
                  Direction Requests<br class="mobile"/>
                  from Business Profile
                </p>
              </div>
              <b>{{seoMain.direction_requests_from_business_profile}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_call.png"/>
                <p>
                  Call Made<br class="mobile"/>
                  from Business Profile
                </p>
              </div>
              <b>{{seoMain.call_made_from_business_profile}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_jt.png"/>
                <p>
                  Website Clicks<br class="mobile"/>
                  form Business Profile
                </p>
              </div>
              <b>{{seoMain.website_clicks_from_business_profile}}</b>
            </div>
          </div>
        </div>
        <div class="bigItem">
          <h1>SEO</h1>
          <div class="contentSmall">
            <div class="item">
              <div>
                <img src="../assets/imgs/home_start.png"/>
                <p>
                  Unique Visitor
                </p>
              </div>
              <b>{{seoMain.unique_visitor}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_img.png"/>
                <p>
                  Page Views
                </p>
              </div>
              <b>{{seoMain.page_views}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_book.png"/>
                <p>
                  Average Engagement Rate
                </p>
              </div>
              <b>{{seoMain.average_engagement_rate}}</b>
            </div>
            <div class="item">
              <div>
                <img src="../assets/imgs/home_time.png"/>
                <p>
                  Average Session Duration
                </p>
              </div>
              <b>{{seoMain.average_session_duration}}</b>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="reputation" v-if="on('promoter')">
      <div class="title">
        Reputation
        <a @click="go('/reviewManagement')">More Info<i class="el-icon-more"></i></a>
      </div>
      <div class="list">
        <div class="item" @click="go('/reviewManagement?type=0')">
          <img src="../assets/imgs/icons/icon_pro6.png"/>
          <div class="left">
            <h1>Google</h1>
            <p><b>{{review.google.user_ratings_total}}</b>Reviews</p>
          </div>
          <div class="right">
            <a>Average Rating</a>
            <el-rate
              v-model="review.google.rating" disabled>
            </el-rate>
            <span>{{review.google.rating}} / 5</span>
          </div>
        </div>
        <div class="item" @click="go('/reviewManagement?type=1')">
          <img src="../assets/imgs/icons/icon_pro5.png"/>
          <div class="left">
            <h1>Yelp</h1>
            <p><b>{{review.yelp.user_ratings_total}}</b>Reviews</p>
          </div>
          <div class="right">
            <a>Average Rating</a>
            <el-rate
              v-model="review.yelp.rating" disabled>
            </el-rate>
            <span>{{review.yelp.rating}} / 5</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi } from '@/network/manageApi';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { serviceOn } from '@/utils/services'
  export default {
    name: 'Home',
    components: {

    },
    data() {
      return {
        value:4.5,
        loading:false,
        loadingInquiries:false,
        loadingReputation:false,
        loadingMedia:false,
        socialMediaAnalytics:{},
        seoMain:{},
        inquiry:{},
        review:{google:{},yelp:{}},
        instagram_url: "",
        facebook_url: ""
      }
    },
    computed: {
      ...mapGetters(['headimgurl']),
      ...mapGetters(['services'])
    },
    created(){
      this.loading = true
      this.loadingMedia = true
      this.loadingInquiries = true
      this.loadingReputation = true
      const params = {
        year:0,
        month:0
      }

      // blocks of services that are off for the company are hidden and not loaded (utils/services.js)
      if (this.on('social')) {
      getActionApi('/socialmedia/instagram/information').then((res) => {
        this.instagram_url = res.data[0].url
      })
      getActionApi('/socialmedia/facebook/information').then((res) => {
        this.facebook_url = res.data[0].facebook_url
      })

      }

      if (this.on('seo')) {
      getActionApi('/seo/main',params).then((res) => {
        this.seoMain = res.data
        if(!this.seoMain.public_files_uuid) {
          this.seoMain.public_files_uuid = this.headimgurl
        }
      }).catch((err) => {
        this.$message.error(err.response.data.details.data.message)
      }).finally((res) => {
        this.loading = false
      });

      }

      if (this.on('social')) {
      getActionApi('/socialmedia/main',params).then((res) => {
        this.socialMediaAnalytics = res.data
      }).catch((err) => {
        this.$message.error(err.response.data.details.data.message)
      }).finally((res) => {
        this.loadingMedia = false
      });

      }

      if (this.on('call')) {
      getActionApi('/inquiry/main').then((res) => {
        this.inquiry = res.data
      }).catch((err) => {
        this.$message.error(err.response.data.details.data.message)
      }).finally((res) => {
        this.loadingInquiries = false
      });

      }

      if (this.on('promoter')) {
      getActionApi('/review/main').then((res) => {
        this.review = res.data
      }).catch((err) => {
        this.$message.error(err.response.data.details.data.message)
      }).finally((res) => {
        this.loadingReputation = false
      });
      }
    },
    methods:{
      on(key) {
        return serviceOn(this.services, key)
      },
      jump_to_external_links(url) {
        window.open(url)
      },
      getImg(url){
        return `${process.env.VUE_APP_BASE_API}/public-file/public/`+url
      },
      go(url) {
        this.$router.push(url);
      },
      getMonStr(mon){
        const monStr = ["January","February","March","April","May","June","July","August","September","October","November","December"]
        return monStr[mon-1]
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  #home .div:nth-child(1){display: grid;grid-template-columns: 300px 1fr;gap: 20px;}
  .inquiries{display: flex;flex-direction: column;}
  .inquiries .list{height:320px;display: grid;grid-template-rows: 1fr 1fr 1fr;gap: 1px;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03);background-color: #ffffff;border-radius: 16px;padding:20px;}
  .inquiries .list .item{cursor: pointer;display: flex;align-items: center;border-bottom:1px solid #DDDDDD;}
  .inquiries .list .item:last-child{border-bottom-width: 0;}
  .inquiries .list .item div{display: flex;flex-direction: column;}
  .inquiries .list .item div h1{font-size:12px;color:#A0AEC0;font-weight: normal;margin-bottom:5px;}
  .inquiries .list .item div p{font-size: 20px;color:#2D3748;font-weight: bold;display: flex;align-items:flex-end;line-height: 1;}
  .inquiries .list .item div p span{font-size: 14px;color:#48BB78;margin-left:10px;}
  .inquiries .list .item .icon{width:45px;height:45px;flex-shrink: 0;margin-right:20px;background:#EEEEFF;border-radius:50%;display: flex;justify-content: center;align-items: center;color:#5856D6;font-size:20px;}
  .analytics{display: flex;flex-direction: column;}
  .analytics .list{display: grid;gap: 20px;grid-template-columns: 1fr 1fr 1fr 1fr;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03);background-color: #ffffff;padding:30px 20px 10px 20px;border-radius: 16px;}
  .analytics .list .item{height:280px;display: flex;flex-direction: column;align-items: center;justify-content: space-between;width: 100%;}
  .analytics .list .item img{height:60px;width:60px;}
  .analytics .list .item h1{color:#2D3648;font-size:20px;margin:10px 0;}
  .analytics .list .item div{width:100%;display: flex;margin:10px 0;justify-content: space-between;font-size: 12px;color:#A0ABC0;}
  .analytics .list .item div span{border-radius: 10px;width: 40px;height: 20px;display: flex;align-items: center;justify-content: center;color:#ffffff;margin-right: 5px;}
  .analytics .list .item p{width: 100%;color:#717D96;font-size:14px;line-height: 2;display: flex;align-items: center;justify-content: space-between;}
  .analytics .list .item p b{color:#2D3648;margin-left:10px;}
  .seo{display: flex;flex-direction: column;}
  .seo .img{background-color: #ffffff;margin-bottom:14px;padding:20px;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);border-radius: 16px;}
  .seo .img img{max-height:60px;}
  .seo .img div{border-top:1px solid #A0AEC0;margin-top:10px;padding-top:10px;display: flex;flex-direction: column;}
  .seo .img p{font-size: 12px;color:#4A5468;line-height: 2;}
  .seo .img b{color:#4A5468;font-size:16px;padding:10px 0;}
  .seo .img a{color:#4299E1;font-size:12px;text-decoration: underline;cursor: pointer;}
  .seo .list{display: grid;gap: 14px;grid-template-columns: 1fr 1fr 1fr 1fr;}
  .seo .list .item{height:80px;background-color: #ffffff;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);border-radius: 16px;padding:0 30px;display: flex;align-items: center;}
  .seo .list .item i{color:#5856D6;font-size:30px;margin-right: 20px;}
  .seo .list .item div{display: flex;flex-direction: column;font-size: 12px;color:#A0AEC0;}
  .seo .list .item div b{font-size: 20px;color: #2D3748;}
  .reputation{display: flex;flex-direction: column;}
  .reputation .list{display: grid;gap:20px;grid-template-columns: 1fr 1fr;}
  .reputation .list .item{height:134px;background-color: #ffffff;cursor: pointer;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03);border-radius: 16px;padding:0 20px;display: flex;align-items: center;}
  .reputation .list .item img{width:76px;height:76px;flex-shrink: 0;margin-right:15px;}
  .reputation .list .item .left{width: 100%;display: flex;flex-direction: column;color:#A0ABC0;font-size: 12px;}
  .reputation .list .item .left h1{font-size: 20px;color: #A0ABC0;}
  .reputation .list .item .left p{font-size:14px;color:#717D96;margin-bottom:5px;}
  .reputation .list .item .left p b{font-size: 20px;color:#2D3648;margin-right: 10px;}
  .reputation .list .item .right{flex-shrink: 0;display: flex;align-items: center;flex-direction: column;}
  .reputation .list .item .right a{color:#A0AEC0;font-size: 12px;margin-bottom: 5px;}
  .reputation .list .item .right span{color:#4A5468;font-size: 14px;font-weight: bold;margin-top:5px;}
  .title{display: flex;justify-content: space-between;align-items: center;height:50px;font-size:20px;color:#2D3648;font-weight: bold;padding:0 10px;}
  .title a{font-size:14px;color:#717D96;font-weight: normal;cursor: pointer;flex-shrink: 0;}
  .title a i{color:#717D96;font-size: 14px;margin-left:10px;}
  .newContent{display: grid;grid-template-columns: 1fr 1fr;gap:20px;margin-bottom: 20px;}
  .newContent .bigItem{border-radius: 16px;background-color: #ffffff;box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03);padding:30px;}
  .newContent .bigItem h1{font-size: 20px;margin-bottom: 20px;}
  .newContent .bigItem .contentSmall{display: grid;grid-template-columns: 1fr 1fr;gap:1px;background-color: #DDDDDD;}
  .newContent .bigItem .contentSmall .item{display: flex;flex-direction: column;justify-content: space-between;height:140px;padding:20px;background-color: #ffffff;}
  .newContent .bigItem .contentSmall .item div{display: flex;}
  .newContent .bigItem .contentSmall .item div img{flex-shrink: 0;height: 18px;margin-right: 10px;}
  .newContent .bigItem .contentSmall .item div p{color:#A0ABC0;}
  .newContent .bigItem .contentSmall .item b{align-self: flex-end;font-size: 18px;}
  @media (max-width: 768px) {
    #home .div:nth-child(1){grid-template-columns: 1fr;}
    .seo .list .item{padding:0 0 0 15px;}
    .reputation .list .item img{width:50px;height:50px;flex-shrink: 0;margin-right:10px;}
    .seo .list .item i{color:#5856D6;font-size:20px;margin-right: 10px;}
    .inquiries .list{height:288px;display: grid;grid-template-rows: 1fr 1fr 1fr;grid-template-columns: 1fr;gap: 14px;}
    .seo .list{gap: 14px;grid-template-columns: 1fr 1fr;}
    .analytics .list{gap: 14px;grid-template-columns: 1fr 1fr;grid-template-rows: 1fr 1fr;}
    .reputation .list{gap:20px;grid-template-columns: 1fr;grid-template-rows: 1fr 1fr;}
    .title{font-size:16px !important;}
    .newContent{grid-template-columns: 1fr;}
    .newContent .bigItem{padding:10px 20px;}
    .newContent .bigItem .contentSmall{grid-template-columns: 1fr;}
    .newContent .bigItem .contentSmall .item{padding:15px 0 10px 0;height: 100px;}
    .mobile {display: none;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    #home .div:nth-child(1){grid-template-columns: 1fr;}
    .inquiries .list{height:98px;display: grid;grid-template-columns: 1fr 1fr 1fr;grid-template-rows: 1fr;gap: 14px;}
    .seo .list{height:174px;display: grid;gap: 14px;grid-template-columns: 1fr 1fr;}
  }

  .negative_number { color: #F56565 !important;}
  .last-tip {font-size: 12px;color: #A0ABC0;margin-top: 5px;}
</style>
